"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, type FC, type PropsWithChildren, use, useState } from "react";
import { useStore } from "zustand";
import { createFlashcardSetsStore, type FlashcardSetState, type FlashcardSetsStore } from "~/client/services";
interface FlashcardSetsStoreProviderProps {
  readonly initialState?: FlashcardSetState;
}
type FlashcardSetsStoreApi = ReturnType<typeof createFlashcardSetsStore>;
export const FlashcardSetsStoreContext = createContext<FlashcardSetsStoreApi | undefined>(undefined);
export const FlashcardSetsStoreProvider: FC<PropsWithChildren<FlashcardSetsStoreProviderProps>> = t0 => {
  const $ = _c(7);
  const {
    children,
    initialState: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {
      data: [],
      isPending: false
    } : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const initialState = t2;
  let t3;
  if ($[2] !== initialState) {
    t3 = () => createFlashcardSetsStore(initialState);
    $[2] = initialState;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [store] = useState(t3);
  let t4;
  if ($[4] !== children || $[5] !== store) {
    t4 = <FlashcardSetsStoreContext value={store}>{children}</FlashcardSetsStoreContext>;
    $[4] = children;
    $[5] = store;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const useFlashcardSetsStore = selector => {
  const store = use(FlashcardSetsStoreContext);
  if (!store) {
    throw new Error("useFlashcardSetsStore must be used within a FlashcardSetsStoreProvider");
  }
  return useStore(store, selector);
};